<template>
  <div id="app">
    <div v-if="$route.meta.keepAlive">
      <headers></headers>
      <router-view></router-view>
      <fixed></fixed>
      <footers></footers>
    </div>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import headers from "@/components/headers";
import footers from "@/components/footers";
import fixed from "@/components/fixed";
export default {
  name: "app",
  components: {
    headers,
    footers,
    fixed
  }
};
</script>
<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color:rgba(51,51,51,1);
}

</style>
